/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */
// import core & vendor packages below

import moment from 'moment';
import { Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toast } from 'react-toastify';
import Table from 'components/ReactTable';
import TableUI from 'components/UI/TableUI';
import ConditionalRender from 'components/ConditionalRender';
import { selectPatientItem, showPatient } from 'reducers/patientReducer';
import { getOrdersList, selectnurse, resetOrderListState } from 'reducers/nurseReducer';

import './OrdersTable.scss';
import { getItems } from 'reducers/departmentInventoryReducer';

const OrdersTable = ({ showProfile, setShowModal }) => {
  const dispatch = useDispatch();
  const orderState = useSelector(selectnurse);
  const { orderItems } = orderState;
  const patientProfile = useSelector(selectPatientItem);

  const [state, setState] = useState([]);

  const tableColumns = React.useMemo(
    () => [
      { Header: 'Patient Name', accessor: 'name' },
      { Header: 'Item Ordered', accessor: 'item_ordered' },
      { Header: 'Ordered By', accessor: 'ordered_by' },
      { Header: 'Ordered Date', accessor: 'ordered_date' },
      { Header: 'Priority Level', accessor: 'priority_level' },
      { Header: 'Total Amount', accessor: 'total_amount' },
    ],
    [],
  );

  const tableData = React.useMemo(
    () =>
      state?.map((dd) => {
        const orderList = dd?.data?.relationships?.order_items?.data;

        const getItems = (type) => {
          const newData = orderList.map((od, idx) => {
            const orderData = orderItems.find(
              (d) => +d?.id === +od?.id && d?.type === 'order_items',
            );

            const itemData = orderItems.find(
              (d) => +d?.id === +orderData?.attributes?.item_id && d?.type === 'items',
            );

            if (type === 'name') return <li>{itemData?.attributes?.name}</li>;

            if (type === 'description') return <li>{itemData?.attributes?.description}</li>;

            if (type === 'quantity') return <li>{orderData?.attributes?.quantity}</li>;

            return itemData;
          });

          return newData;
        };

        return {
          data: dd,
          id: dd?.id,
          name: dd?.name,
          ordered_by: dd?.ordered_by,
          total_amount: dd?.total_amount,
          priority_level: dd?.priority_level,
          item_ordered: <ul className='table-list'>{getItems('name')}</ul>,
          ordered_date: moment(dd?.ordered_date).format('MMM-DD-YYYY hh:mm A'),
        };
      }),
    [state],
  );

  triggerAPI(showProfile, dispatch, patientProfile);

  getDataFromStore(orderState, setState, dispatch);

  useEffect(() => {
    console.log('Order state', state);
  }, [state]);

  return (
    <div className='patientProfile__header'>
      <h4>Orders</h4>
      <Row>
        <Col>
          <TableUI>
            <Table
              data={tableData}
              columns={tableColumns}
              pagination={['BOTTOM']}
              logs={orderState?.orderLogs}
              customAction={(id) => {
                const row = tableData.find((dd) => dd.id === id);
                const canDelete = true;

                const buttons = [
                  {
                    text: 'Delete',
                    color: 'red',
                    action: () => {
                      setShowModal((prevState) => {
                        return {
                          ...prevState,
                          data: row,
                          deleteModal: true,
                        };
                      });
                    },
                    condition: canDelete === true,
                  },
                ];

                return (
                  <div className='action-buttons'>
                    {buttons.map((buttonData) => {
                      return (
                        <ConditionalRender
                          condition={buttonData?.condition}
                          renderIf={
                            <span
                              className={`badge ${buttonData?.color}`}
                              style={{ cursor: 'pointer' }}
                              onClick={buttonData?.action}
                            >
                              {buttonData?.text}
                            </span>
                          }
                        />
                      );
                    })}
                  </div>
                );
              }}
            />
          </TableUI>
        </Col>
      </Row>
    </div>
  );
};

const triggerAPI = (showProfile, dispatch, patientProfile) => {
  useEffect(() => {
    if (showProfile?.profileId && patientProfile) {
      const params = {
        per_page: 100000,
        patient_id: showProfile?.profileId,
        patient_visit_number: patientProfile?.active_visit_number,
      };

      dispatch(getOrdersList(params));
    }
  }, [showProfile, patientProfile]);
};

const getDataFromStore = (orderState, setState, dispatch) => {
  const { orderLogs, orderData, orderItems } = orderState;

  useEffect(() => {
    const { isSuccess, isFailed } = orderLogs;

    if (isSuccess) {
      const filteredData = orderData.map((data) => {
        return {
          data: data,
          id: data?.id,
          name: data?.attributes?.patient_name,
          patient_id: data?.attributes?.patient_id,
          ordered_by: data?.attributes?.orderer_name,
          ordered_id: data?.attributes?.orderer_id,
          ordered_date: data?.attributes?.created_at,
          priority_level: data?.attributes?.priority_level,
          total_amount: data?.attributes?.total_amount,
        };
      });

      setState(filteredData);
    }

    if (isFailed) {
      const { error } = orderLogs;

      toast.error(error[0]?.detail);

      dispatch(resetOrderListState());
    }
  }, [orderLogs]);
};

export default OrdersTable;
